import {View} from 'react-native'
import {Trans} from '@lingui/react/macro'

import {atoms as a} from '#/alf'
import * as Admonition from '#/components/Admonition'
import {Warning_Stroke2_Corner0_Rounded as WarningIcon} from '#/components/icons/Warning'
import {Text} from '#/components/Typography'
import {useSemanticTokens} from '#/wsocial/service/design-system'

export function ChatDisclaimer() {
  const ss = useSemanticTokens()

  return (
    <View style={[a.px_xl, a.py_md]}>
      <Admonition.Outer type="tip">
        <Admonition.Row>
          <WarningIcon fill={ss.admonition.tipColor} size="md" />
          <Admonition.Content>
            <Text style={[a.text_xs, a.font_semi_bold, a.leading_snug]}>
              <Trans>Disclaimer</Trans>
            </Text>
            <Admonition.Text>
              <Trans>
                You can communicate with users across the AT Protocol network,
                including people on platforms such as Bluesky. Messages are not
                stored on W Social's servers, but may be stored on other servers
                within the network. These communications are not end-to-end
                encrypted.
              </Trans>
            </Admonition.Text>
            <Admonition.Text>
              <Trans>
                W Social is currently exploring the development of its own chat
                infrastructure, including end-to-end encryption, to enhance user
                privacy and security in the future.
              </Trans>
            </Admonition.Text>
          </Admonition.Content>
        </Admonition.Row>
      </Admonition.Outer>
    </View>
  )
}
